import lang from '../lang/language.js';
import format from '../utils/format.js';

class ValidationError {
  constructor(key, args) {
    this._key = key;
    this._args = args || [];
  }

  key() {
    return this._key;
  }
  
  args() {
    return this._args;
  }
  
  text() {
    let text = lang.getText(this._key);
    if (this._textDoesNotContainPlaceholder(text) && this._hasVariables()) {
      text += ' ({0})';
    }
    return format(text, this._args);
  }

  _hasVariables() {
    return this._args.length > 0;
  }

  _textDoesNotContainPlaceholder(text) {
    return text.indexOf('{0}') === -1;
  }
}

export default ValidationError;
